<template>
	<v-row no-gutters class="mt-4">
		<v-row no-gutters style="position: relative">
			<v-text-field
				outlined
				dense
				label="パーソナルカラー(必須)"
				v-model="setPersonalColor"
        hint="英語のみ対応しています。パレットアイコンから色の選択が可能です。"
			>
			</v-text-field>
			<v-menu v-model="colorPicker" :close-on-content-click="false">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon color="secondary" v-bind="attrs" v-on="on">
						<v-icon> mdi-palette </v-icon>
					</v-btn>
				</template>
				<v-card elevation="5">
					<v-color-picker v-model="colorData"> </v-color-picker>
					<v-row no-gutters class="pa-2" justify="center">
						<v-btn @click="setColor(colorData)" color="secondary">色を決定</v-btn>
					</v-row>
				</v-card>
			</v-menu>
		</v-row>
	</v-row>
</template>

<script>
export default {
	props: {
		personalColor: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			colorData: null,
			colorPicker: false,
		}
	},
	methods: {
		setColor(color) {
			if (color) {
				const rgba = color.rgba
				const rgbaColor = `rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a})`
				this.setPersonalColor = rgbaColor
			}
			this.colorPicker = false
		},
	},

	computed: {
		setPersonalColor: {
			get() {
				return this.personalColor
			},
			set(newValue) {
				return this.$emit("update:personalColor", newValue)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.picker-container {
	position: absolute;
	bottom: 0;
	top: 100%;
	right: 0;
	height: 300px;
	background-color: white;
	z-index: 5;
	&__row {
		width: 100% !important;
		max-width: 100% !important;
		padding: 8px;
	}
	.delete-btn {
		position: absolute;
		top: -10px;
		right: -10px;
		z-index: 6;
		height: 24px !important;
		width: 24px !important;
	}
}
</style>
